/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Image, Space } from "antd";
import { NavLink } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Button, TextField, Box, TableRow, TableCell } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import { emptyValidation, customAlaphabetValidation, customAlaphabetValidationOptional } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { currencyHead } from "../../../../../config/constant";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const ListTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [currencyId, setCurrencyId] = useState('');
    const [name, setName] = useState('');
    const [shortName, setShortName] = useState('');
    const [symbol, setSymbol] = useState('');
    const [errorName, setErrorName] = useState('');
    const [errorShortName, setErrorShortName] = useState('');
    const [errorSymbol, setErrorSymbol] = useState('');
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);

    const dispatch = useDispatch();

    const onEdit = (data) => {
        setVisible(true);
        setCurrencyId(data.id);
        setName(data.name);
        setShortName(data.shortName);
        setSymbol(data.symbol);
    }

    const emptyState = () => {
        setErrorName(false);
        setErrorShortName(false);
        setErrorSymbol(false);
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'name') {
                setErrorName(error[1]);
            }
        }
    }, [editDetails, editError, prevEditDetails, prevEditError]);

    const onDelete = (data) => {
        setDeleteModal(true);
        setCurrencyId(data.id);
        setName(data.name);
    }


    const editCurrency = (e) => {
        e.preventDefault();
        let emptyName = customAlaphabetValidation('Name', name);
        let emptyShortName = customAlaphabetValidationOptional('Short Name', shortName);
        let emptySymbol = emptyValidation('Symbol', symbol);
        emptyState();
        if (emptyName.isValid && emptyShortName.isValid && emptySymbol.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'currency',
                id: currencyId,
                title: 'Currency',
                details: {
                    name: name,
                    shortName: shortName,
                    symbol: symbol
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyShortName.errors) {
                setErrorShortName(emptyShortName.errors);
            }
            if (emptySymbol.errors) {
                setErrorSymbol(emptySymbol.errors);
            }
        }
    }

    const classes = customStyles()

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={currencyHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell style={{ width: getColumnWidth(currencyHead, 0) }}><span style={{ width: getColumnWidth(currencyHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(currencyHead, 1) }}><span style={{ width: getColumnWidth(currencyHead, 1) }}>{data.shortName ? data.shortName : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(currencyHead, 2) }}><span style={{ width: getColumnWidth(currencyHead, 2) }}>{`${data.symbol}`}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Currency', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Currency', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Currencies'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Currency'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editCurrency(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                value={name}
                                error={errorName ? true : false}
                                helperText={errorName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Short Name'
                                variant={'standard'}
                                value={shortName}
                                className={clsx(classes.margin30t)}
                                error={errorShortName ? true : false}
                                helperText={errorShortName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setShortName(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={["Symbol ", <span key={"Symbol"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                className={clsx(classes.margin30t)}
                                value={symbol}
                                error={errorSymbol ? true : false}
                                helperText={errorSymbol}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setSymbol(e.target.value)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="yes"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            >
                                Update &amp; Close
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={currencyId} loadTasks={() => loadTasks()} name={name} url={'currency'} title={'Currency'} visible={deleteModal} />
        </>
    )
}